import FingoMuiTextField from '../../fingo/components/MuiTextField';
import {
  LOGIN_OUTLINED_INPUT_CLASS_NAME,
  SECONDARY_OUTLINED_INPUT_CLASS_NAME,
} from '../../constants/outlined-input';

const getSecondaryOutlinedFieldStyles = ({ theme }) => ({
  position: 'relative',
  '& .MuiOutlinedInput-root': { height: 48 },
  '& .MuiOutlinedInput-notchedOutline, &:hover .MuiOutlinedInput-notchedOutline, &.Mui-focused .MuiOutlinedInput-notchedOutline, &.Mui-error .MuiOutlinedInput-notchedOutline, &.Mui-error:hover .MuiOutlinedInput-notchedOutline': {
    borderColor: `${theme.palette.primary.main} !important`,
  },
  '& .MuiInputBase-input': {
    ...theme.typography.small_2,
    color: `${theme.palette.primary.main} !important`,
  },
  '& .MuiInputLabel-root': {
    ...theme.typography.small_2,
    color: `${theme.palette.primary.main} !important`,
  },
  '& .MuiOutlinedInput-notchedOutline legend': { fontSize: 11 },
  '& .MuiFormHelperText-root': {
    ...theme.typography.small_2,
    color: theme.palette.secondary.main,
    position: 'absolute',
    top: '100%',
    left: 0,
    margin: 0,
  },
  '& .MuiIconButton-root, & .MuiIconButton-root .MuiSvgIcon-root': {
    color: `${theme.palette.primary.main} !important`,
  },
});

const getLoginOutlinedFieldStyles = ({ theme }) => ({
  '& .MuiOutlinedInput-root': { height: 40 },
  '& .MuiOutlinedInput-input': { padding: theme.spacing(0, 2), fontSize: 14 },
  '& .MuiInputLabel-root': { fontSize: 16, fontWeight: 600 },
  '& .MuiOutlinedInput-notchedOutline legend': { fontSize: 12, fontWeight: 600 },
});

const MuiTextField = {
  ...FingoMuiTextField,
  styleOverrides: {
    ...FingoMuiTextField.styleOverrides,
    root: ({ theme }) => ({
      ...FingoMuiTextField.styleOverrides.root,
      [`&.${SECONDARY_OUTLINED_INPUT_CLASS_NAME}`]: getSecondaryOutlinedFieldStyles({ theme }),
      [`&.${LOGIN_OUTLINED_INPUT_CLASS_NAME}`]: getLoginOutlinedFieldStyles({ theme }),
    }),
  },
};

export default MuiTextField;
